import { Box } from "@mui/material";
import React from 'react';
import { useLocation } from 'react-router-dom';
import InnovationPlazaSetting from '../../components/admin/settings/InnovationPlazaSetting';
import ProductFormatSetting from '../../components/admin/settings/ProductFormatSetting';
import ReminderSetting from "../../components/admin/settings/ReminderSetting";
import BreadcrumbGenerator from '../../components/common/BreadcrumbGenerator';
import AdminLayout from "../../layouts/admin/AdminLayout";
import AuthContext from '../../route/AuthContext';

const Settings = () => {

  const {user} = React.useContext(AuthContext);
  const location = useLocation();

  const contentBreadcrumb = BreadcrumbGenerator.generateContent(user?.role ?? '', location.pathname);

  return (
    <AdminLayout
      breadcrumb={contentBreadcrumb}
      title="Impostazioni | Piattaforma Innovation ReSearch"
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 1
      }}>
        {user?.role === 'ADMINISTRATOR' && <ReminderSetting/>}
        {user?.role === 'ADMINISTRATOR' && <InnovationPlazaSetting/>}
        <ProductFormatSetting />
      </Box>
    </AdminLayout>
  );
};

export default Settings;
